/* Origami & Co. 送料の目安（国 × 個数）。データは oc-ship-data.js（window.OC_SHIP）。
   .ocship[data-mode] … product：その商品の数量の欄に合わせる／collection：個数を打つ／cart：カートの中身から出す */
(function () {
  if (window.__ocShipInit) return;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.oc-qty__b');
    if (!b) return;
    var i = b.parentNode.querySelector('input');
    i.value = Math.max(1, Math.min(99, (parseInt(i.value, 10) || 1) + parseInt(b.getAttribute('data-d'), 10)));
  });
  window.__ocShipInit = true;
  var D = window.OC_SHIP;
  if (!D) return;
  var KEY = 'ocShipCountry';
  var names;
  try { names = new Intl.DisplayNames(['en'], { type: 'region' }); } catch (e) { names = null; }
  function nameOf(c) { try { return names ? names.of(c) : c; } catch (e) { return c; } }
  function yen(n) { return Number(n).toLocaleString('en-US') + ' JPY'; }
  /* 手持ちの段ボールに詰めて、箱ごとに 実重量 と 容積重量（縦×横×高さ÷5,000）の大きい方を 0.5kg 単位で切り上げて合計（shipping_estimate.py の pack と同じ） */
  function prod(a) { return a[0] * a[1] * a[2]; }
  function sorted(a) { return a.slice().sort(function (x, y) { return x - y; }); }
  function kgOf(lines) {
    var pk = D.packing;
    var cartons = pk.cartons.slice().sort(function (a, b) { return prod(a.cm) - prod(b.cm); });
    var units = [];
    lines.forEach(function (l) {
      var t = D.types[l.type] || D.types.expansion;
      for (var i = 0; i < l.qty; i++) units.push({ g: t.g + pk.per_unit_g, cm: sorted(t.cm), v: prod(t.cm) });
    });
    units.sort(function (a, b) { return b.v - a.v; });
    function vsum(us) { return us.reduce(function (s, u) { return s + u.v; }, 0); }
    function fits(c, us) {
      var cm = sorted(c.cm);
      return vsum(us) <= prod(c.cm) * pk.fill && us.every(function (u) { return u.cm[0] <= cm[0] && u.cm[1] <= cm[1] && u.cm[2] <= cm[2]; });
    }
    var rest = units, total = 0, n = 0;
    while (rest.length && n++ < 200) {
      var c = null, take, left;
      for (var i = 0; i < cartons.length; i++) if (fits(cartons[i], rest)) { c = cartons[i]; break; }
      if (c) { take = rest; rest = []; }
      else {
        c = cartons[cartons.length - 1]; take = []; left = [];
        var cap = prod(c.cm) * pk.fill;
        rest.forEach(function (u) { (vsum(take) + u.v <= cap ? take : left).push(u); });
        if (!take.length) { take = [rest[0]]; left = rest.slice(1); }
        rest = left;
      }
      var g = pk.base_g + take.reduce(function (s, u) { return s + u.g; }, 0);
      var volkg = Math.ceil(prod(c.cm) / 5000 * 10) / 10;
      total += Math.max(Math.ceil(Math.max(g / 1000, volkg) * 2) / 2, 0.5);
    }
    return total;
  }
  function priceOf(code, kg) {
    var c = D.countries[code];
    if (!c) return null;
    if (kg > D.max_kg) return 'large';
    return c.p[Math.round(kg / D.step_kg) - 1] || null;
  }
  /* 国は Shopify の国（右上の国の選択）を優先する。送れない国のときだけ、前に選んだ国か米国 */
  function savedCountry(def) {
    if (D.countries[def]) return def;
    var c = null;
    try { c = localStorage.getItem(KEY); } catch (e) {}
    return D.countries[c] ? c : 'US';
  }
  var codes = Object.keys(D.countries).sort(function (a, b) { return nameOf(a).localeCompare(nameOf(b)); });

  function setup(el) {
    var sel = el.querySelector('select');
    var def = el.getAttribute('data-country') || 'US';
    sel.innerHTML = codes.map(function (c) { return '<option value="' + c + '">' + nameOf(c) + '</option>'; }).join('');
    sel.value = savedCountry(def);
    sel.addEventListener('change', function () {
      try { localStorage.setItem(KEY, sel.value); } catch (e) {}
      document.querySelectorAll('.ocship select').forEach(function (s) { s.value = sel.value; });
      runAll();
      /* 右上の国（Shopify の国・レジの国）も同じ国にする。表示を合わせるためページを読み直す（カートは残る） */
      if (window.ocSetShopCountry && el.getAttribute('data-country') !== sel.value) {
        window.ocSetShopCountry(sel.value).then(function () { location.reload(); });
      }
    });
    var qty = el.querySelector('.ocship-qty');
    if (qty) qty.addEventListener('input', function () { run(el); });
  }

  function show(el, lines, goods) {
    var out = el.querySelector('.ocship-out');
    var code = el.querySelector('select').value;
    var n = lines.reduce(function (s, l) { return s + l.qty; }, 0);
    if (!n) { out.innerHTML = 'Add items to see the shipping estimate.'; return; }
    var kg = kgOf(lines), p = priceOf(code, kg);
    var what = el.getAttribute('data-mode') === 'cart' ? n + ' item' + (n > 1 ? 's' : '') : n + ' box' + (n > 1 ? 'es' : '');
    if (p === 'large') out.innerHTML = 'Large order (' + what + '): <b>contact us for an exact quote.</b>';
    else if (!p) out.innerHTML = 'Please contact us for shipping to ' + nameOf(code) + '.';
    else out.innerHTML = 'Estimated shipping for ' + what + ': <b>' + yen(p) + '</b> <span>· about ' + kg + ' kg · tracked</span>';
    var c = D.countries[code];
    var warn = el.querySelector('.ocship-warn');
    if (warn) warn.textContent = c && c.eu && goods !== null && goods < D.eu_min_jpy ? 'EU orders need at least ' + yen(D.eu_min_jpy) + ' (€150) in goods.' : '';
  }

  function run(el) {
    var mode = el.getAttribute('data-mode');
    if (mode === 'product') {
      var form = document.querySelector('form[action*="/cart/add"] input[name="quantity"]') || document.querySelector('input[name="quantity"]');
      var q = Math.max(1, parseInt((form && form.value) || '1', 10) || 1);
      var price = parseInt(el.getAttribute('data-price') || '0', 10);
      var h = el.getAttribute('data-type');
      show(el, [{ type: D.items[h] || (/psa/.test(h) ? 'psa' : /bulk|lot/.test(h) ? 'bulk100' : 'expansion'), qty: q }], price * q);
    } else if (mode === 'collection') {
      var q2 = Math.max(1, Math.min(99, parseInt(el.querySelector('.ocship-qty').value || '1', 10) || 1));
      show(el, [{ type: el.getAttribute('data-type') || 'expansion', qty: q2 }], null);
    } else {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var lines = cart.items.map(function (i) { return { type: D.items[i.handle] || (/(psa|graded)/i.test(i.product_type || '') ? 'psa' : /lot/i.test(i.product_type || '') ? 'bulk100' : 'expansion'), qty: i.quantity }; });
        show(el, lines, cart.items_subtotal_price / 100);
      }).catch(function () {});
    }
  }
  function runAll() { document.querySelectorAll('.ocship').forEach(run); }

  function init() {
    document.querySelectorAll('.ocship:not([data-ready])').forEach(function (el) { el.setAttribute('data-ready', '1'); setup(el); run(el); });
  }
  var t;
  function later() { clearTimeout(t); t = setTimeout(function () { init(); runAll(); }, 700); }
  document.addEventListener('change', function (e) { if (e.target && e.target.name && /quantity|updates/.test(e.target.name)) later(); });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('quantity-input button, cart-remove-button, .quantity__button, [name="add"], cart-drawer, #CartDrawer')) later(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  new MutationObserver(function () { if (document.querySelector('.ocship:not([data-ready])')) later(); }).observe(document.body, { childList: true, subtree: true });
})();
